import OrderServeType from '@/constants/OrderServeType';
import { parsePhoneNumber } from 'libphonenumber-js/max';
import { isEmpty, cloneDeep } from 'lodash';
import { availableLocales } from '@/constants/locale';

const updateOrderMenuLocale = (orderVo, locale) => {};

export const updateNewOrderInfoToOrderVo = (
  webStoreVo,
  orderVo,
  customizeWelcomeReducer
) => {
  if (
    isEmpty(webStoreVo) ||
    isEmpty(orderVo) ||
    isEmpty(customizeWelcomeReducer)
  )
    return {};

  const cloneOrderVo = cloneDeep(orderVo);
  const {
    welcomeLocale,
    selectedServeType,
    selectedTakeOutServeType,
    customerName,
    selectedAreaCode,
    customerPhone,
    customerAddress,
    selectedDatePreorderTime,
    selectedTimePreorderTime,
    shareMealCondiction,
    customerComment,
  } = customizeWelcomeReducer;

  // 服務類型
  if (selectedServeType) {
    cloneOrderVo.orderType = 'NEW';
    cloneOrderVo.serveType = selectedServeType;
  }
  // 菜單語系
  webStoreVo.langs.map((lang: any) => {
    Object.keys(availableLocales).map((key) => {
      if (availableLocales[key].lang === lang && key === welcomeLocale) {
        cloneOrderVo.menuLocale = lang;
      }
      return false;
    });
    return false;
  });

  // 手機
  if (customerPhone) {
    let phoneNumber = String(selectedAreaCode.areaCode + customerPhone);
    if (customerPhone.includes('+')) {
      phoneNumber = String(customerPhone);
    }
    const parsePhone = parsePhoneNumber(phoneNumber, selectedAreaCode.iti);
    cloneOrderVo.table.mobile = parsePhone
      .formatInternational()
      .replaceAll(' ', '');
    cloneOrderVo.table.country = selectedAreaCode.country;
  }
  // 姓名
  if (customerName) {
    cloneOrderVo.customerName = customerName;
  }
  // 地址
  if (customerAddress && selectedServeType === OrderServeType.DELIVERY) {
    cloneOrderVo.customerAddress = customerAddress;
  }
  // 時間
  if (
    selectedTimePreorderTime &&
    (selectedServeType === OrderServeType.DELIVERY ||
      (selectedServeType === OrderServeType.TAKE_OUT &&
        selectedTakeOutServeType === OrderServeType.SCHEDULE_TAKE_OUT))
  ) {
    cloneOrderVo.preorderTime = selectedTimePreorderTime;
  }
  // 共鍋費
  if (shareMealCondiction && selectedServeType === OrderServeType.DINE_IN) {
    Object.keys(shareMealCondiction).forEach((key) => {
      cloneOrderVo.conditions[shareMealCondiction[key].id] =
        shareMealCondiction[key].count;
    });
  }

  // 備註
  if (selectedServeType === OrderServeType.DELIVERY)
    cloneOrderVo.comment = customerComment;

  return cloneOrderVo;
};

export const updateExistingOrderInfoToOrderVo = (
  webStoreVo,
  orderVo,
  customizeWelcomeReducer
) => {
  if (
    isEmpty(webStoreVo) ||
    isEmpty(orderVo) ||
    isEmpty(customizeWelcomeReducer)
  )
    return {};
  const cloneOrderVo = cloneDeep(orderVo);
  const {
    welcomeLocale,
    selectedServeType,
    customerName,
    selectedAreaCode,
    customerPhone,
    shareMealCondiction,
  } = customizeWelcomeReducer;

  // 服務類型
  if (selectedServeType === OrderServeType.DINE_IN) {
    cloneOrderVo.orderType = 'EXISTING';
    cloneOrderVo.serveType = selectedServeType;
  }
  // 菜單語系
  webStoreVo.langs.map((lang: any) => {
    Object.keys(availableLocales).map((key) => {
      if (availableLocales[key].lang === lang && key === welcomeLocale) {
        cloneOrderVo.menuLocale = lang;
      }
      return false;
    });
    return false;
  });
  // 手機
  if (customerPhone && selectedServeType === OrderServeType.DINE_IN) {
    const phoneNumber = customerPhone?.includes('+')
      ? customerPhone
      : selectedAreaCode.areaCode + customerPhone;
    const parsePhone = parsePhoneNumber(phoneNumber, selectedAreaCode.iti);
    cloneOrderVo.table.mobile = parsePhone
      .formatInternational()
      .replaceAll(' ', '');
    cloneOrderVo.table.country = selectedAreaCode.country;
  }
  // 共鍋費
  if (shareMealCondiction && selectedServeType === OrderServeType.DINE_IN) {
    Object.keys(shareMealCondiction).forEach((key) => {
      cloneOrderVo.conditions[shareMealCondiction[key].id] =
        shareMealCondiction[key].count;
    });
  }

  return cloneOrderVo;
};

export const updateAddonOrderInfoToOrderVo = (
  webStoreVo,
  orderVo,
  customizeWelcomeReducer
) => {
  if (
    isEmpty(webStoreVo) ||
    isEmpty(orderVo) ||
    isEmpty(customizeWelcomeReducer)
  )
    return {};

  const cloneOrderVo = cloneDeep(orderVo);
  const {
    welcomeLocale,
    selectedServeType,
    customerName,
    selectedAreaCode,
    customerPhone,
    shareMealCondiction,
  } = customizeWelcomeReducer;

  // 服務類型
  if (selectedServeType === OrderServeType.DINE_IN) {
    cloneOrderVo.orderType = 'ADDON';
    cloneOrderVo.serveType = selectedServeType;
  }
  // 菜單語系
  webStoreVo.langs.map((lang: any) => {
    Object.keys(availableLocales).map((key) => {
      if (availableLocales[key].lang === lang && key === welcomeLocale) {
        cloneOrderVo.menuLocale = lang;
      }
      return false;
    });
    return false;
  });
  // 手機
  if (customerPhone && selectedServeType === OrderServeType.DINE_IN) {
    const phoneNumber = customerPhone?.includes('+')
      ? customerPhone
      : selectedAreaCode.areaCode + customerPhone;
    const parsePhone = parsePhoneNumber(phoneNumber, selectedAreaCode.iti);
    cloneOrderVo.table.mobile = parsePhone
      .formatInternational()
      .replaceAll(' ', '');
    cloneOrderVo.table.country = selectedAreaCode.country;
  }
  // 共鍋費
  if (shareMealCondiction && selectedServeType === OrderServeType.DINE_IN) {
    Object.keys(shareMealCondiction).forEach((key) => {
      cloneOrderVo.conditions[shareMealCondiction[key].id] =
        shareMealCondiction[key].count;
    });
  }

  return cloneOrderVo;
};
